import { Status, Configuration } from 'services/moneyline/moneyline.types';
import { RootState } from '../store';
import { HardwareState } from './hardware.reducer';

export const getHardware = (state: RootState): HardwareState => state.hardware;

export const getStatus = (state: RootState): Status | undefined =>
  getHardware(state)?.status;

export const isReady = (state: RootState): boolean =>
  getHardware(state) !== null && getStatus(state)?.PRINTER_RECEIPT === true;

export const getConfiguration = (state: RootState): Configuration | undefined =>
  getHardware(state)?.configuration;
